import * as React from "react";
import { Card, PageHeader, Tabs } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import CustomerReturnIntake from "./CustomerReturnIntake";
import IssuedOrders from "./IssuedOrders";

type IntakeMode = "supplier" | "customer";

const parseModeFromSearch = (search: string): IntakeMode => {
  const params = new URLSearchParams(search);
  return params.get("source") === "customer" ? "customer" : "supplier";
};

export default function IncomingGoodsIntake() {
  const history = useHistory();
  const location = useLocation();

  const [mode, setMode] = React.useState<IntakeMode>(() => parseModeFromSearch(location.search));

  React.useEffect(() => {
    setMode(parseModeFromSearch(location.search));
  }, [location.search]);

  const handleModeChange = (nextMode: string) => {
    const selected = nextMode === "customer" ? "customer" : "supplier";
    setMode(selected);

    const params = new URLSearchParams(location.search);
    params.set("source", selected);
    history.replace({ pathname: location.pathname, search: params.toString() ? `?${params}` : undefined });
  };

  return (
    <>
      <PageHeader className="site-page-header" title="Príjem tovaru" subTitle="Dodávatelia aj zákazníci" />

      <Card>
        <Tabs activeKey={mode} onChange={handleModeChange}>
          <Tabs.TabPane key="supplier" tab="Príjem od dodávateľa">
            <IssuedOrders />
          </Tabs.TabPane>
          <Tabs.TabPane key="customer" tab="Príjem od zákazníka">
            <CustomerReturnIntake inCard active={mode === "customer"} />
          </Tabs.TabPane>
        </Tabs>
      </Card>
    </>
  );
}
